import React, { useEffect, useRef, useState } from 'react'
import { WidgetType } from '../../types/widget-type'
import { convertWidgetToHtmlString } from '~/utils/transform';
import CollectEmail from '~/components/CollectEmail';
import { useApollo } from '~/utils/apollo-client';
import { QUERY_GET_CMS_BLOCKS } from '~/data/home';

const BlockByWidgetType = ({ inputString }: { inputString: string }) => {
    const [data, setData] = useState<string | null>(null);
    const apolloClient = useApollo(undefined);
    const formRef = useRef(null);

    useEffect(() => {
        const getData = async () => {
            const data = await convertWidgetToHtmlString(inputString, getComponentByType);
            setData(data);
        }

        getData();
    }, [convertWidgetToHtmlString, inputString]);

    const getComponentByType = async (type: WidgetType) => {
        const { data } = await apolloClient.query({
            query: QUERY_GET_CMS_BLOCKS,
            variables: {
                identifiers: [type]
            },
            context: { fetchOptions: { method: 'GET' } },
        })
        switch (type) {
            case WidgetType.COLLECT_EMAIL:
                return data?.cmsBlocks?.items?.[0]?.content;
            default:
                return ""
        }
    }

    useEffect(() => {
        const intervalId = setInterval(() => {
            // Check if the div with id 'replaceMe' exists in the DOM
            if (formRef.current) {
                const divToReplace = (formRef.current as any).querySelector('#submit-email-form');
                if (divToReplace) {
                    // Replace the div with new content
                    const newElement = document.querySelector('#email-form');
                    divToReplace.replaceWith(newElement);

                    // Clear the interval once the div is found and replaced
                    clearInterval(intervalId);
                }
            }
        }, 100); // Check every 100ms

        const timeoutId = setTimeout(() => {
            clearInterval(intervalId);
            console.error('Failed to find #submit-email-form within 10 seconds');
        }, 10000);

        // Cleanup the interval when the component is unmounted
        return () => {
            clearInterval(intervalId);
            clearTimeout(timeoutId);
        };
    }, []);

    if (!data) return null;
    return <>

        <div dangerouslySetInnerHTML={{
            __html: data
        }} ref={formRef} />
        <div className='hidden'>
            <CollectEmail />
        </div>
    </>

}

export default BlockByWidgetType